import React from 'react';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import DeleteNoteTabDrawer from '../components/DeleteNoteTabDrawer';
import NoteTabFormDrawer from '../components/NoteTabFormDrawer';
export default function useNoteTabActions(note, draftActions) {
    const addTab = useStableCallback((onNewTabActive) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(NoteTabFormDrawer, { noteID: note.id, onSubmit: (data) => {
                    const noteTabID = draftActions.appendNoteTab(data.title);
                    bottomDrawerHelperActions.hide();
                    onNewTabActive(noteTabID);
                } })),
        });
    });
    const editTab = useStableCallback((tab) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(NoteTabFormDrawer, { noteID: note.id, noteTab: tab, onSubmit: (data) => {
                    draftActions.updateNoteTabTitle(tab.id, data.title);
                    bottomDrawerHelperActions.hide();
                } })),
        });
    });
    const deleteTab = useStableCallback((tab) => {
        return new Promise((resolve) => {
            bottomDrawerHelperActions.show({
                component: (React.createElement(DeleteNoteTabDrawer, { onDelete: () => {
                        draftActions.removeNoteTab(tab.id);
                        resolve(true);
                    }, onCancel: () => {
                        resolve(false);
                    } })),
                onClose() {
                    resolve(false);
                },
            });
        });
    });
    const state = {};
    const actions = {
        addTab,
        editTab,
        deleteTab,
    };
    return [state, actions];
}
